import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

const styles = theme => ({
  title: {
    padding: 30,
    color: '#687783',
  }
});


class PageTitle extends Component {

  render() {
    const { classes, title } = this.props;
    return (
      <div>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} sm={8}>
            <div>
              <Typography className={classes.title} variant="h2">
                {title}
              </Typography>
            </div>
            <Divider />
          </Grid>
        </Grid>
      </div>
    )
  }
}

PageTitle.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(PageTitle);


